<template></template>

<script>
    import StorageBase from "./ModelStorageBase";
    var jsondiffpatch = require('jsondiffpatch').create({
        objectHash: function (obj, index) {
            return '$$index:' + index;
        },
    });

    export default {
        name: 'model-panel',
        mixins: [StorageBase],
        model: {
            prop: '_value',
            event: '_value-change'
        },
        props: {
            // value: Object,
            _value:{
                type: Object,
                default: function () {
                    return null;
                }
            },
            readOnly: {
                type: Boolean,
                default: function () {
                    return false
                }
            },
            image: {
                type: String,
                default: ''
            },
        },
        data: function () {
            return {
                elementId: null,
                user: {},
                value: null,
                copyValue: null,

                params: null,
                fullPath: null,
                paramKeys: null,
                canvasbase: null,
            }
        },
        created() {
            var me = this
            try{
                // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! Check Model.
                // component 호출시 작동시 예외처리.
                // console.log('image', me.image)
                me.canvasbase = me.$parent ? me.$parent.getComponent('event-storming-model-canvas') : me.getComponent('event-storming-model-canvas')
                me.value = JSON.parse(JSON.stringify(me._value))

                // console.log('ModelPanel - Created')
                // me.copyValue = JSON.parse(JSON.stringify(me.value))
                me.elementId = me.value.elementView ? me.value.elementView.id : me.value.relationView.id


                me.params = this.$route.params
                me.paramKeys = Object.keys(me.params)
                me.fullPath = this.$route.fullPath.split('/')


                me.user.uid = localStorage.getItem('uid')
                me.user.name = localStorage.getItem('userName')
                me.user.email = localStorage.getItem('email')
                me.user.picture = localStorage.getItem('picture')
                me.user.accessToken = localStorage.getItem('accessToken')
            }catch (e) {
                console.log(e)
            }

        },
        beforeDestroy() {

        },
        computed: {
            fixedDefalutStroage() {
                return 'db'
            },
            isReadOnly() {
                //get props
                return this.readOnly

                if (this.canvasbase) {
                    return this.canvasbase.readOnly
                }
            },
            modelingProjectId(){
                if (this.canvasbase) {
                    return this.canvasbase.modelingProjectId
                }
                return this.params.projectId ? this.params.projectId : null
            },
            isCustomMoveExist() {
                if (this.canvasbase) {
                    if (this.isServerModeling && this.isQueueModeling) {
                        return !this.isReadModeling
                    }
                }
                return false
            },
            isReadModeling() {
                if (this.canvasbase)
                    return this.canvasbase.isReadModeling
                return false
            },
            isClazzModeling() {
                if (this.canvasbase)
                    return this.canvasbase.isClazzModeling
                return false
            },
            isServerModeling() {
                if (this.canvasbase)
                    return this.canvasbase.isServerModeling
                return false
            },
            isQueueModeling() {
                if (this.canvasbase) {
                    return this.canvasbase.isQueueModeling
                } else {
                    return false
                }
            },

        },
        methods: {
            closePanel(){
                this.$emit('close')
            },
            panelOpenQueue(editUser) {
                var me = this
                var obj = {
                    action: 'userPanelOpen',
                    editUid: editUser ? editUser.uid : me.user.uid,
                    name:editUser ? editUser.name :me.user.name,
                    picture: editUser ? editUser.picture : me.user.picture,
                    timeStamp: Date.now(),
                    editElement: me.elementId
                }
                me.pushObject(`db://definitions/${me.modelingProjectId}/queue`, obj)
            },
            panelCloseQueue(editUser) {
                var me = this
                var obj = null
                obj = {
                    action: 'userPanelClose',
                    editUid: editUser ? editUser.uid : me.user.uid,
                    name: editUser ? editUser.name :me.user.name,
                    picture: editUser ? editUser.picture : me.user.picture,
                    timeStamp: Date.now(),
                    editElement: me.elementId
                }

                me.pushObject(`db://definitions/${me.modelingProjectId}/queue`, obj)
            },
            getComponent(componentName) {
                let component = null
                let parent = this.$parent
                while (parent && !component) {
                    if (parent.$options.name === componentName) {
                        component = parent
                    }
                    parent = parent.$parent
                }
                return component
            },
            getComponentByName: function (name) {
                var componentByName;
                $.each(window.Vue._components, function (i, component) {
                    if (component.name == name) {
                        componentByName = component;
                    }
                });
                return componentByName;
            },
            executeBeforeDestroy(){
                var me = this
                try{
                    /*
                        _value : 기존 값.
                        value  : Panel 사용되는 값,
                    */
                    var diff = jsondiffpatch.diff(me._value, me.value)
                    if (diff) {
                        if (!me.readOnly) {
                            me.canvasbase.changedByMe = true
                            me.$emit('_value-change', me.value)
                        }
                    }
                }catch (e) {
                    alert('[Error] ModelPanel Sync: ', e)
                }
            }
        },

    }
</script>


<style lang="scss" rel="stylesheet/scss">
    .v-icon.outlined {
        border: 1px solid currentColor;
        border-radius: 0%;
    }

    .md-sidenav .md-sidenav-content {
        width: 400px;
    }

    .md-sidenav.md-right .md-sidenav-content {
        width: 600px;
    }

    .flip-list-move {
        transition: transform 0.5s;
    }

    .no-move {
        transition: transform 0s;
    }

    .ghost {
        opacity: 0.5;
        background: #c8ebfb;
    }

    .list-group {
        min-height: 20px;
    }

    .list-group-item {
        cursor: move;
    }

    .list-group-item i {
        cursor: pointer;
    }
</style>
